// JsFromRoutes CacheKey 4bee0796bb1bde465a7ce88d17c3385b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  reorder: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/categories/reorder'),
  cover: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/categories/:id/cover'),
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/help/categories'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/help/categories/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/help/categories/:id'),
}
